<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="name"
              v-model="targetAudience.name"
              value=""
              placeholder="Nome"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissionais",
          routerName: "Professional",
        },
        {
          name: "Novo Público Alvo",
          routerName: "RegisterTargetAudience",
        },
      ],
      targetAudience: {
        name: "",
      },
      targetAudienceParams: this.$route.params,
      selectedCategory: "",
      dataProps: { module: "Professional" },
    };
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      targetAudienceData: "Professional/targetAudience",
    }),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions("Professional", [
      "registerTargetAudience",
      "consultTargetAudience",
      "setDataDefault",
    ]),
    async handleSubmit() {
      let message = this.targetAudience?.id
        ? "Público alvo editado com sucesso!"
        : "Público alvo cadastrado com sucesso!";

      await this.registerTargetAudience(this.targetAudience);
      this.$router.push({ name: "ListTargetAudience" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
  },
  async mounted() {
    if (
      this.targetAudienceParams &&
      Object.keys(this.targetAudienceParams).length > 0
    ) {
      await this.consultTargetAudience(this.targetAudienceParams);
      this.dataProps = {
        name: this.targetAudienceData.name,
        id: this.targetAudienceParams.id,
        module: "Professional",
        type: "TargetAudience",
      };
      this.targetAudience = this.targetAudienceData;
      this.links[1].name = this.targetAudience.name;
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
